import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { isMobileOnly } from "react-device-detect"

const query = graphql`
  {
    fotka: file(relativePath: { eq: "img1.jpg" }) {
      childImageSharp {
        fluid(quality: 60) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const SideLadowarki = () => {
  const data = useStaticQuery(query)


  return (
    <BackgroundImage
      Tag="section"
      className={`col-12 col-lg-6 side-1`}
      fluid={data.fotka.childImageSharp.fluid}
      backgroundColor={`#000`}
    >
      <div className="bg-overlay"></div>
      <div
        data-sal={!isMobileOnly ? "slide-up" : ""}
        data-sal-delay="500"
        data-sal-duration="600"
        data-sal-easing="ease"
        className="box p-3 p-md-5 ie11animfix"
      >
        <Link to="our-chargers" title="Our chargers">
          <div className="box-title">OUR CHARGERS</div>
          <p className="mb-3">
            <span>
              Three charger models – Ekoenergetyka, ABB and Efacec – are
              available to EV drivers at ORLEN stations.{" "}
              <strong>
                All chargers are equipped with three connector types:
              </strong>{" "}
              two DC connectors (CCS and CHAdeMO) and one AC connector (Type 2).
              Most of our chargers are located at ORLEN service stations.
            </span>
          </p>
          <span className="link-more">Our chargers</span>
        </Link>
      </div>
    </BackgroundImage>
  )
}


export default SideLadowarki

